import medal from "assets/images/medal.svg"
import { Card } from "materia"
import type { PropsWithChildren, ReactNode } from "react"
import { FiestaLink, type FiestaLinkProps } from "utility-components"
import { Widget } from "../../Widget"
import s from "./LeaderboardWidget.module.scss"

type LeaderboardWidgetProps = {
  ariaLabel: string
  link: FiestaLinkProps
  children: ReactNode
}
export const LeaderboardWidget = ({
  ariaLabel,
  link,
  children,
}: LeaderboardWidgetProps) => (
  <Widget>
    <FiestaLink {...link} ariaLabel={ariaLabel}>
      <div className={s.leaderboard}>{children}</div>
    </FiestaLink>
  </Widget>
)

type HeaderProps = {
  title: string
  caption: string
}
const Header = ({ title, caption }: HeaderProps) => (
  <div className={s.header}>
    <img className={s.header__icon} src={medal} alt="" />
    <h2>
      <div className={s.header__caption}>{caption}</div>
      <div className={s.header__title}>{title}</div>
    </h2>
  </div>
)

const Entries = ({ children }: PropsWithChildren) => (
  <ul className={s.entries}>{children}</ul>
)

const Skeleton = () => (
  <Card>
    <div className={s.skeleton} />
  </Card>
)

LeaderboardWidget.Header = Header
LeaderboardWidget.Entries = Entries
LeaderboardWidget.Skeleton = Skeleton
